import uniqid from 'uniqid'
import GitHubIcon from '@material-ui/icons/GitHub'
import LaunchIcon from '@material-ui/icons/Launch'
import './ProjectContainer.css'

const ProjectContainer = ({ project }) => (
  <div className={`project ${project.featured ? 'project--featured' : ''}`}>
    {project.previewImage && (
      <div className='project__preview-wrapper'>
        <img
          src={project.previewImage}
          alt={`${project.name} preview`}
          className='project__preview'
          loading='lazy'
        />
      </div>
    )}

    <h3 className='project-name'>{project.name}</h3>
    <p className='project__description'>{project.description}</p>

    {project.stack && (
      <ul className='project__stack'>
        {project.stack.map((item) => (
          <li key={uniqid()} className='project__stack-item'>
            {item}
          </li>
        ))}
      </ul>
    )}

    <div className='project__actions'>
      {project.livePreview && (
        <a
          href={project.livePreview}
          target='_blank'
          rel='noreferrer'
          className='project__action'
          aria-label={`${project.liveLabel || 'Open project'}: ${project.name}`}
          title={project.liveLabel || 'Open project'}
        >
          <LaunchIcon fontSize='small' />
        </a>
      )}

      {project.sourceCode && (
        <a
          href={project.sourceCode}
          target='_blank'
          rel='noreferrer'
          className='project__action'
          aria-label={`${project.sourceLabel || 'Source code'}: ${project.name}`}
          title={project.sourceLabel || 'Source code'}
        >
          <GitHubIcon fontSize='small' />
        </a>
      )}
    </div>
  </div>
)

export default ProjectContainer
